import { t } from '@lingui/core/macro';
import { NoddiButton } from 'noddi-ui-web';
import { useState } from 'react';
import { TireInformationDialog } from './TireInformationDialog';

export const TireInformationButton = () => {
  const [isTireInfoDialogOpen, setIsTireInfoDialogOpen] = useState(false);

  return (
    <>
      <div className='flex justify-end'>
        <NoddiButton onClick={() => setIsTireInfoDialogOpen(true)} variant='outline' startIcon='Info' size='extraSmall'>
          {t`General tire information`}
        </NoddiButton>
      </div>

      <TireInformationDialog open={isTireInfoDialogOpen} onClose={() => setIsTireInfoDialogOpen(false)} />
    </>
  );
};
